import * as focusTrap from 'focus-trap';

export default class ToggleMenuMobile {
    constructor() {
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            myToggleMenuMobile: document.querySelector(".header-mobile__btn"),
            myNavMobile: document.querySelector("#nav-mobile"),
            myNavMobileClose: document.querySelector("#navigationMobile__close"),
            myNavMobileHeader: document.querySelector(".header-mobile__content"),
            myNavMobileInner: document.querySelector(".header-mobile__inner"),
            myNavMobileModalBtn: document.querySelectorAll("#nav-mobile .js-modal-button"),
            myNavMobileModalClose: document.querySelectorAll("#dialog__layer .btn-close"),
            body: document.querySelector("body"),
            html: document.querySelector("html")
        }
    }

    listen() {
        if(this.ui.myToggleMenuMobile) {
            this.ui.myToggleMenuMobile.addEventListener("click", e => { // Au click sur le menu burger mobile
                e.preventDefault();
                this.ui.myNavMobile.style.display = "block";
                this.ui.myToggleMenuMobile.setAttribute('aria-expanded', 'true');
                setTimeout(() => {
                    this.ui.body.classList.add('nav-mobile-open');
                }, 100);
                setTimeout(() => {
                    this.ui.myNavMobileClose.focus(); // Focus sur le bouton fermer
                }, 300);
                this.ui.body.style.overflow = 'hidden';
                this.ui.html.style.overflow = 'hidden';
                const heightMobileHeader = (this.ui.myNavMobileHeader.clientHeight / 16) + 'rem'; // Hauteur du header mobile
                this.ui.myNavMobileInner.style.height =  'calc(-' + heightMobileHeader + ' + 100vh)'; // Hauteur du contenu du menu mobile
                this.focusTrapHeader = focusTrap.createFocusTrap(this.ui.myNavMobile, {
                    initialFocus: false,
                    allowOutsideClick: true,
                    clickOutsideDeactivates: true,
                    onActivate: () => this.ui.myNavMobile.classList.add('is-active'),
                    onDeactivate: () => this.ui.myNavMobile.classList.remove('is-active'),
                });
                if (this.focusTrapHeader) {
                    this.focusTrapHeader.activate();
                }
            });

            this.ui.body.addEventListener("keyup", e => { // Fermeture du sous-menu lors de ECHAP
                const menuMobileOpen = document.querySelector(".header-mobile__btn[aria-expanded='true']");
                if (e.key === "Escape") {
                    if(menuMobileOpen !== null && !this.ui.body.classList.contains("has-dialog")) {
                        this.ui.myNavMobileClose.click(); // Fermeture de la nav mobile s'il n'y a pas de modale par dessus
                    }
                    if(this.ui.body.classList.contains("has-dialog") && this.ui.body.classList.contains("nav-mobile-open")) {
                        this.focusTrapHeader.activate(); // Activation du focusTrap sur la nav mobile
                    }
                }
            });

            this.ui.myNavMobileClose.addEventListener("click", e => { // Au click sur le bouton fermer
                e.preventDefault();
                this.ui.body.classList.remove('nav-mobile-open');
                this.ui.myToggleMenuMobile.setAttribute('aria-expanded', 'false');
                setTimeout(() => {
                    this.ui.myNavMobile.removeAttribute("style");
                }, 300);
                this.ui.body.removeAttribute("style");
                this.ui.html.removeAttribute("style");
                this.ui.myNavMobileInner.removeAttribute("style");
                if (this.focusTrapHeader) {
                    this.focusTrapHeader.deactivate(); // Désactivation du focusTrap sur la nav mobile
                }
                this.ui.myToggleMenuMobile.focus(); // Focus sur le burger menu
            });

            this.ui.myNavMobileModalBtn.forEach((item) => {
                item.addEventListener("click", () => { // Au click sur les boutons d'ouverture de modale
                    if (this.focusTrapHeader) {
                        this.focusTrapHeader.deactivate(); // Désactivation du focusTrap sur la nav mobile
                    }
                });
            });

            this.ui.myNavMobileModalClose.forEach((item) => {
                item.addEventListener("click", () => { // Au click sur les boutons de fermeture de modale
                    if(this.ui.body.classList.contains("nav-mobile-open")) {
                        if (this.focusTrapHeader) {
                            this.focusTrapHeader.activate(); // Activation du focusTrap sur la nav mobile
                        }
                    }
                });
            });
        }
    }
}